import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'nl2br'
})
export class Nl2BrPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.replace(/\n/g, '<br>'); // Replace newlines with <br>
  }
}
